import { render, staticRenderFns } from "./indexv1.vue?vue&type=template&id=46f8f951&scoped=true&"
import script from "./indexv1.vue?vue&type=script&lang=js&"
export * from "./indexv1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f8f951",
  null
  
)

export default component.exports